/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CoverageResponseDto,
  CreateOperatingAreaDto,
  OperatingAreaDto,
  UpdateWarehouseDto,
  WarehouseDto,
} from '../models/index';
import {
    CoverageResponseDtoFromJSON,
    CoverageResponseDtoToJSON,
    CreateOperatingAreaDtoFromJSON,
    CreateOperatingAreaDtoToJSON,
    OperatingAreaDtoFromJSON,
    OperatingAreaDtoToJSON,
    UpdateWarehouseDtoFromJSON,
    UpdateWarehouseDtoToJSON,
    WarehouseDtoFromJSON,
    WarehouseDtoToJSON,
} from '../models/index';

export interface AddOperatingAreaRequest {
    orgId: number;
    createOperatingAreaDto: CreateOperatingAreaDto;
}

export interface GetAllWarehousesRequest {
    page: number;
    organizationId?: number;
    countryCode?: string;
    isActive?: boolean;
    pageSize?: number;
}

export interface GetCoverageStatusRequest {
    orgId: number;
}

export interface GetOperatingAreasRequest {
    orgId: number;
}

export interface GetWarehouseByIdRequest {
    id: number;
}

export interface GetWarehouseCatalogRequest {
    id: number;
    query?: string;
    pageSize?: number;
    page?: number;
}

export interface RemoveOperatingAreaRequest {
    orgId: number;
    areaId: number;
}

export interface UpdateWarehouseRequest {
    id: number;
    updateWarehouseDto: UpdateWarehouseDto;
}

/**
 * 
 */
export class WarehouseServiceApi extends runtime.BaseAPI {

    /**
     * Assign operating area to supplier organization
     */
    async addOperatingAreaRaw(requestParameters: AddOperatingAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperatingAreaDto>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling addOperatingArea().'
            );
        }

        if (requestParameters['createOperatingAreaDto'] == null) {
            throw new runtime.RequiredError(
                'createOperatingAreaDto',
                'Required parameter "createOperatingAreaDto" was null or undefined when calling addOperatingArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organizations/{orgId}/operating-areas`.replace(`{${"orgId"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOperatingAreaDtoToJSON(requestParameters['createOperatingAreaDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperatingAreaDtoFromJSON(jsonValue));
    }

    /**
     * Assign operating area to supplier organization
     */
    async addOperatingArea(requestParameters: AddOperatingAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperatingAreaDto> {
        const response = await this.addOperatingAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all warehouses (admin view)
     */
    async getAllWarehousesRaw(requestParameters: GetAllWarehousesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getAllWarehouses().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/warehouses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * List all warehouses (admin view)
     */
    async getAllWarehouses(requestParameters: GetAllWarehousesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllWarehousesRaw(requestParameters, initOverrides);
    }

    /**
     * Get coverage status for supplier organization
     */
    async getCoverageStatusRaw(requestParameters: GetCoverageStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CoverageResponseDto>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling getCoverageStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organizations/{orgId}/coverage`.replace(`{${"orgId"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoverageResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get coverage status for supplier organization
     */
    async getCoverageStatus(requestParameters: GetCoverageStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CoverageResponseDto> {
        const response = await this.getCoverageStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get operating areas assigned to supplier organization
     */
    async getOperatingAreasRaw(requestParameters: GetOperatingAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OperatingAreaDto>>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling getOperatingAreas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organizations/{orgId}/operating-areas`.replace(`{${"orgId"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OperatingAreaDtoFromJSON));
    }

    /**
     * Get operating areas assigned to supplier organization
     */
    async getOperatingAreas(requestParameters: GetOperatingAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OperatingAreaDto>> {
        const response = await this.getOperatingAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get warehouse by ID (admin view)
     */
    async getWarehouseByIdRaw(requestParameters: GetWarehouseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getWarehouseById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/warehouses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDtoFromJSON(jsonValue));
    }

    /**
     * Get warehouse by ID (admin view)
     */
    async getWarehouseById(requestParameters: GetWarehouseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseDto> {
        const response = await this.getWarehouseByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get warehouse catalog (admin view)
     */
    async getWarehouseCatalogRaw(requestParameters: GetWarehouseCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getWarehouseCatalog().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/warehouses/{id}/catalog`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get warehouse catalog (admin view)
     */
    async getWarehouseCatalog(requestParameters: GetWarehouseCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getWarehouseCatalogRaw(requestParameters, initOverrides);
    }

    /**
     * Remove operating area from supplier organization
     */
    async removeOperatingAreaRaw(requestParameters: RemoveOperatingAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperatingAreaDto>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling removeOperatingArea().'
            );
        }

        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling removeOperatingArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organizations/{orgId}/operating-areas/{areaId}`.replace(`{${"orgId"}}`, encodeURIComponent(String(requestParameters['orgId']))).replace(`{${"areaId"}}`, encodeURIComponent(String(requestParameters['areaId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperatingAreaDtoFromJSON(jsonValue));
    }

    /**
     * Remove operating area from supplier organization
     */
    async removeOperatingArea(requestParameters: RemoveOperatingAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperatingAreaDto> {
        const response = await this.removeOperatingAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update warehouse (admin)
     */
    async updateWarehouseRaw(requestParameters: UpdateWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateWarehouse().'
            );
        }

        if (requestParameters['updateWarehouseDto'] == null) {
            throw new runtime.RequiredError(
                'updateWarehouseDto',
                'Required parameter "updateWarehouseDto" was null or undefined when calling updateWarehouse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/warehouses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWarehouseDtoToJSON(requestParameters['updateWarehouseDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDtoFromJSON(jsonValue));
    }

    /**
     * Update warehouse (admin)
     */
    async updateWarehouse(requestParameters: UpdateWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseDto> {
        const response = await this.updateWarehouseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
